import * as React from "react";
import OdxAreaHeader from "../../../OdxComponents/NativeOdx/Odx-AreaHeader";
import OdxChip from "../../../OdxComponents/NativeOdx/Odx-Chip";
import {odxVariants} from "../../../OdxComponents/constants";
import {useMain} from "../../../Utils/SessionControls/mainContext";
import OdxBreadcrumbs from "../../../OdxComponents/NativeOdx/Odx-Breadcrumbs";
import OdxContentBox from "../../../OdxComponents/NativeOdx/Odx-Contentbox";

const IDMSDocumentation: React.FC = () => {

    const {setLoading} = useMain();

    setLoading(false)
    return (
        <div>
            <OdxBreadcrumbs/>

            <OdxAreaHeader
                text="Documentation"
                odxSize="large"
                className={'!pl-0 !pr-0'}
            />
            <OdxContentBox>
                <div className="flex items-center mb-4">
                    <OdxChip
                        content="Dräger developed"
                        size="medium"
                        variant={odxVariants.secondary}
                    />
                </div>
                <h5>Overview</h5>
                <ul>
                    <p>Integrated into Azure B2C and Okta, this tool adds user-role information to each user in your app
                        to handle restrictive access, roles and even different tenants. The IDMS is used as a SaaS
                        component for software development. The application acts as a part of the login flow via Azure
                        B2C to add role data in the resulting JWT token after a successful authentication.</p>
                </ul>
                <odx-separator style={{margin: '1rem 0'}} />
                <h5>Features</h5>
                <ul>
                    <li>Tenant Management: A user can be admin in section A and user in section B of your app.</li>
                    <li>Automated roles: Each "@draeger.com" user needs to be admin automatically? Easy!</li>
                    <li>Mail notification: Mail-notification for different events, such as new user signUps.</li>
                    <li>Easy Setup: The Admin portal with options for app-specific roles, user management etc. allows an
                        easy setup of roles and assignment of users.
                    </li>
                </ul>
                <odx-separator style={{margin: '1rem 0'}} />
                <h5>Requirements</h5>
                <ul>
                    <li>Login using Drägers Azure B2C or Okta</li>
                </ul>
                <odx-separator style={{margin: '1rem 0'}} />
                <h5>Set-up of modules for project</h5>
                <ul>
                    <li>Send us your B2C or Okta AppId and the initial roles that are available in your app.</li>
                    <li>Change your B2C Policy or Okta Hook to start receiving roles inside the login-token.</li>
                </ul>
                <odx-separator style={{margin: '1rem 0'}} />
                <h5>Further Documentation</h5>
                <ul>
                    <li>
                        <a href="https://b2cauthorizationhandlerfuncs.azurewebsites.net/api/Wiki">
                            Wiki
                        </a>
                    </li>
                    <li>
                        <a href="https://b2cauthorizationhandlerfuncs.azurewebsites.net/api/swagger">
                            API
                        </a>
                    </li>
                    <li>
                        <a href="https://dev.azure.com/draeger/Mobile%20Solutions%20IDM">
                            DevOps Project
                        </a>
                    </li>
                </ul>
            </OdxContentBox>
        </div>
    );
};

export default IDMSDocumentation;
